export default "/53b1a42f38b4b7b261a10aab262cb0a1.svg";